/* global $, $$ */ /* Bliss */
export class ToggleElements {
  constructor() {
    $.delegate(document.body, 'click', '[data-toggle-element]', e => {
      e.preventDefault()

      let target = e.target && e.target.closest('[data-toggle-element]')
      if (target && target.getAttribute('data-toggle-element')) {
        let el = target.closest(target.getAttribute('data-toggle-element'))
        el.classList.toggle(
          target.getAttribute('data-toggle-class') || 'toggled'
        )

        // call given callback with scope if set. first search scope with 'closest', if none found search globally
        if (
          target.hasAttribute('data-toggle-callback') &&
          target.hasAttribute('data-toggle-callback-scope')
        ) {
          let callbackScope =
            target.closest(target.getAttribute('data-toggle-callback-scope')) ||
            $(target.getAttribute('data-toggle-callback-scope'))
          this[target.getAttribute('data-toggle-callback')].call(
            callbackScope,
            target.getAttribute('data-toggle-class') || 'toggled'
          )
        }
      }
    })

    // fix sizes and positions on resize
    window.addEventListener('resize', () => {
      $$('[data-toggle-callback-on-resize]').forEach(el => {
        let callbackScope =
          el.closest(el.getAttribute('data-toggle-callback-scope')) ||
          $(el.getAttribute('data-toggle-callback-scope'))
        this[el.getAttribute('data-toggle-callback')].call(
          callbackScope,
          el.getAttribute('data-toggle-class') || 'toggled'
        )
      })
    })

    // update height e.g. after images are done loading
    window.addEventListener('load', () => {
      $$('data-toggle-callback-on-load').forEach(el => {
        let callbackScope =
          el.closest(el.getAttribute('data-toggle-callback-scope')) ||
          $(el.getAttribute('data-toggle-callback-scope'))
        this[el.getAttribute('data-toggle-callback')].call(
          callbackScope,
          el.getAttribute('data-toggle-class') || 'toggled'
        )
      })
    })
  }

  foldoutSetSize(toggleClass) {
    if (!this) return

    let $wrapper = $('.js-foldout-wrapper', this)
    let $body = $('.js-foldout-body', this)

    if (!$wrapper || !$body) return

    if (this.classList.contains(toggleClass)) {
      $.style($wrapper, {height: $body.offsetHeight + 'px'})
    } else {
      $.style($wrapper, {height: '0px'})
    }
  }
}
